import React, { Component } from 'react'
import moment from "moment"
import { session } from "services/session"
import ApiHelper from "services/api-helper"
import { Button, Form, Select, TextArea, Modal } from "semantic-ui-react"
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import toastr from 'toastr'

export default class KhaiBaoViecLamTaoMoi extends Component {
  state = {
    buoiList: [
      { value: 1, text: 'Cả ngày' },
      { value: 2, text: 'Sáng' },
      { value: 3, text: 'Chiều' }
    ],
    obj: {
      TuNgay: moment().startOf('day'),
      DenNgay: moment().startOf('day'),
      Buoi: 1,
      NoiDung: ''
    }
  }
  save = () => {
    if (this.state.obj.NoiDung == "") {
      alert("Nhập nội dung làm việc");
      return;
    }
    // ApiHelper.GetJson('api/getKiemTraTrungNgayDangKy', {
    //   IdNhanVien: session.NhanVienId,
    //   TuNgay: this.state.obj.TuNgay,
    //   DenNgay: this.state.obj.DenNgay,
    //   Buoi: this.state.obj.Buoi
    // }).then(res => {
    //   if (res.ok) {
    ApiHelper.PostJson('api/taoKhaiBaoLamViec', {
      IdNhanVien: session.NhanVienId,
      IdBoPhan: session.BoPhanId,
      TuNgay: this.state.obj.TuNgay,
      DenNgay: this.state.obj.DenNgay,
      Buoi: this.state.obj.Buoi,
      IDWebUserTao: session.WebUserId,
      DiaDiem: this.state.obj.DiaDiem,
      NoiDung: this.state.obj.NoiDung
    }).then(res => {
      toastr.success('Thành công!')
      this.props.closeModal()
    }, error => {
      toastr.error(error)
    })
    // } else {
    //   toastr.error(res.message === "TRUNG_NGAY_DANG_KY" ? "Trùng hoặc giao ngày với dữ liệu trước" : 'Lỗi!')
    // }
    // });
  }
  handleChangeDate = (_ref) => {
    var startDate = _ref.startDate || this.state.obj.TuNgay
    var endDate = _ref.endDate || this.state.obj.DenNgay

    if (startDate.isAfter(endDate)) {
      _ref.startDate && (endDate = startDate)
      _ref.endDate && (startDate = endDate)
    }

    this.setState({ obj: { ...this.state.obj, TuNgay: startDate, DenNgay: endDate } })
  }
  handleChangeDateStart = (startDate) => {
    return this.handleChangeDate({ startDate })
  }
  handleChangeDateEnd = (endDate) => {
    return this.handleChangeDate({ endDate })
  }
  handleBuoi = (e, { value }) => {
    this.setState({ obj: { ...this.state.obj, Buoi: value } })
  }
  handleNoiDung = (e, { value }) => {
    this.setState({ obj: { ...this.state.obj, NoiDung: value } })
  }
  handleDiaDiem = (e, { value }) => {
    this.setState({ obj: { ...this.state.obj, DiaDiem: value } })
  }
  render() {
    return (
      <Modal
        open={this.props.openModal}
        onClose={this.props.closeModal}
      >
        <Modal.Header>Khai báo việc làm ở nhà</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths='equal'>
              <Form.Field>
                <label>Ngày</label>
                <DatePicker
                  selected={this.state.obj.TuNgay}
                  selectsStart
                  startDate={this.state.obj.TuNgay}
                  endDate={this.state.obj.DenNgay}
                  onChange={this.handleChangeDateStart}
                  dateFormat="DD/MM/YYYY"
                  placeholderText="Từ ngày"
                />
              </Form.Field>
              {/* <Form.Field>
                <label>Đến ngày</label>
                <DatePicker
                  selected={this.state.obj.DenNgay}
                  selectsEnd
                  startDate={this.state.obj.TuNgay}
                  endDate={this.state.obj.DenNgay}
                  onChange={this.handleChangeDateEnd}
                  dateFormat="DD/MM/YYYY"
                  placeholderText="Đến ngày"
                />
              </Form.Field> */}
              {/* <Form.Field control={Select} label='Buổi' options={this.state.buoiList}
                value={this.state.obj.Buoi}
                onChange={this.handleBuoi}
              /> */}
            </Form.Group>
            <Form.Field>
              <label>Nội dung (*)</label>
              <TextArea className="textarea-kblv" placeholder='Nội dung'
                value={this.state.obj.NoiDung}
                onChange={this.handleNoiDung}
              />
            </Form.Field>
            {/* <Form.Field>
              <label>Địa điểm</label>
              <TextArea placeholder='Địa điểm'
                value={this.state.obj.DiaDiem}
                onChange={this.handleDiaDiem}
              />
            </Form.Field> */}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.props.closeModal} negative>
            Hủy
          </Button>
          <Button
            onClick={this.save}
            positive
            labelPosition='right'
            icon='checkmark'
            content='Lưu'
          />
        </Modal.Actions>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/khai-bao-viec-lam-o-nha/tao-moi-modal.jsx